import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import NotFound from "../../components/NotFound";
import { postData } from "../../services/api";
import { checkIfIsValidEmail } from "../../services/helpers";

function RecoverPassword() {
  const [searchParams,] = useSearchParams();
  const [email, setEmail] = useState("");
  const [markSent, setMarkSent] = useState(false);

  useEffect(() => {
    if (searchParams.get("email")) {
      if (checkIfIsValidEmail(searchParams.get("email")))
        setEmail(searchParams.get("email"));
    }
  }, [searchParams]);

  async function handleSubmitButtonClick(e) {
    e.preventDefault();

    try {
      var response = await postData("/sendEmailPasswordConfirmation", {
        data: {
          email: email
        }
      });
      if (!response) return;
      setMarkSent(true);
    } catch (err) {
      alert(err.message);
    }
  }

  return (
    <React.Fragment>
      {!email ? (<NotFound message="Não foi submetido nenhum email válido." />) :
        !markSent ? (
          <React.Fragment>
            <div className="row">
              <div className="col">
                <p style={{ textAlign: "center" }}>Vamos proceder ao envio de um email com a informação necessária para a alteração da palavra-chave. Carregue no botão abaixo para continuar.</p>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="d-grid gap-2">
                  <button type="button" className="btn btn-dark" onClick={(e) => handleSubmitButtonClick(e)}>Enviar email</button>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="row">
              <div className="col">
                <p style={{ textAlign: "center" }}>O email foi enviado para {email}</p>
              </div>
            </div>
          </React.Fragment>
        )}
    </React.Fragment>
  );
}

export default RecoverPassword;
